import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export interface Language {
  code: string
  name: string
  flag_emoji: string
  status: 'active' | 'draft' | 'archived'
  is_default: boolean
  sort_order: number
}

/**
 * Fetches all languages from the DB, ordered by sort_order.
 * Pass a statusFilter to get a subset client-side — only one HTTP request is made.
 */
export function useLanguages(statusFilter?: Language['status'] | Language['status'][]) {
  const query = useQuery({
    queryKey: ['languages'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('languages')
        .select('code, name, flag_emoji, status, is_default, sort_order')
        .order('sort_order')
      if (error) throw error
      return (data ?? []) as Language[]
    },
    staleTime: 5 * 60 * 1000,
  })

  const all = query.data ?? []

  const languages = statusFilter
    ? all.filter((l) =>
        Array.isArray(statusFilter)
          ? statusFilter.includes(l.status)
          : l.status === statusFilter
      )
    : all

  return { languages, all, isLoading: query.isLoading, error: query.error }
}
